import React, { Component } from 'react';
import Suggestions from './Suggestions';

const MAX_SUGGESTIONS = 10;

const getSuggestions = (searchText) => {
    const suggestions = window._referencableTettraUsers || [];
    searchText = searchText.toLowerCase();
    return suggestions.filter((user) => {
        const displayName = user.display_name.replace(/\s/g, '').toLowerCase();
        const firstName = user.first_name || '';
        const lastName = user.last_name || '';
        const fullName = firstName.concat(lastName).replace(/\s/g, '').toLowerCase();
        return displayName.includes(searchText) || fullName.includes(searchText);
    }).slice(0, MAX_SUGGESTIONS);
};

export default class MentionSuggestions extends Component {
    render() {
        const { insertMention } = this.props;
        return (
            <div className="suggestions internal-suggestions">
                <Suggestions
                    getSuggestions={getSuggestions}
                    selectSuggestion={insertMention}
                    {...this.props}
                />
            </div>
        );
    }
}
